import { useUsersStore } from "@/store/modules/users";

import AtmoChildrens from "@/router/atmo/children";

const OidcCallback = () =>
  import(
    /* webpackChunkName: "OidcCallback" */ "@/components/OidcCallback.vue"
  );

const AtmoMobile = () =>
  import(
    /* webpackChunkName: "AtmoFrontMobile" */ "@/components/AtmoMobile.vue"
  );

const fetchCurrentUser = (from, to, next) => {
  useUsersStore().fetchCurrentUser();
  next();
};

export default [
  {
    path: "/",
    component: AtmoMobile,
    children: AtmoChildrens,
    beforeEnter: fetchCurrentUser,
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
];
